import { Switch } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
// --------------------------------------------------
import { IoSettings } from "react-icons/io5";
import { FaCalendarAlt } from "react-icons/fa";
import { FaCircleInfo } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { FaSave } from "react-icons/fa";
import { FaArrowRotateLeft } from "react-icons/fa6";
// ---------------------------------------------------
import LateSubmissionPenaltySettings from './LateSubmissionPenaltySettings';
import { monthNames, getDaysInMonth, useSelect } from '../../../../../../../services/commonServices';
import { getTDSGeneralRulePath, saveTDSGeneralRulePath } from '../../../../../../../services/config';
import { getTdsGeneralRules, initGenRules, tdsSaveData, initTdsState } from '../../../../../../../redux/slices/tdsSlice';
import { useDispatch } from 'react-redux';

const GeneralRules = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {}
  const dispatch = useDispatch()
  const tdsStore = useSelect("tds")

  const [applyLateSubmition, setApplyLateSubmition] = useState("0")
  const [generalList, setGeneralList] = useState([])
  const [quickPresets, setQuickPresets] = useState(["3 days"])
  const [genaralState, setGeneralState] = useState(
    {
      userId: user.user_id,
      regimeChoice: "", // OLD or NEW
      proofUploadMandatory: "",
      "12bb_form_deadline": "",
      gracePeriod: "",
      isAllowLatePenalty: "",
      activateLateSubmissionPenalty: "",
      deadLineType: "",
      calculationMethod: "",
      lateSubmissionGracePeriod: "",
      penaltyType: "",
      penaltyAmount: "",
      penaltyDetectFromPayroll: "",
      penaltyMaximumCap: "",
      penaltyNotificationAction: "",
      autoExcemptOptions: [],
      manualOverrideExceptions: "",
      auditNote: "",
      deviceName: "laptop",
      ipAddress: ""
    }
  )

  const defaultGeneralState = {
    userId: user.user_id,
    regimeChoice: "",
    proofUploadMandatory: "",
    "12bb_form_deadline": "",
    gracePeriod: "",
    isAllowLatePenalty: "",
    activateLateSubmissionPenalty: "",
    deadLineType: "",
    calculationMethod: "",
    lateSubmissionGracePeriod: "",
    penaltyType: "",
    penaltyAmount: "",
    penaltyDetectFromPayroll: "",
    penaltyMaximumCap: "",
    penaltyNotificationAction: "",
    autoExcemptOptions: [],
    manualOverrideExceptions: "",
    auditNote: "",
    deviceName: "laptop",
    ipAddress: ""
  };

  const handleApplyLateSubmition = ({ target: { checked } }) => {
    setApplyLateSubmition(checked ? "1" : "0")
  }

  const getListGeneral = useCallback(() => {
    dispatch(getTdsGeneralRules(`${getTDSGeneralRulePath}${user.user_id}`))
  }, [])

  useEffect(() => {
    getListGeneral()
  }, [])

  const handleInputChange = ({ target: { value, name } }) => {
    setGeneralState((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const toggleValue = (value) => {
    setGeneralState((prev) => ({
      ...prev,
      autoExcemptOptions: prev.autoExcemptOptions.includes(value)
        ? prev.autoExcemptOptions.filter((v) => v !== value) // remove
        : [...prev.autoExcemptOptions, value] // add
    }));
  };

  const handleSwitchChange = ({ target: { name, checked } }) => {
    setGeneralState((pre) => ({
      ...pre,
      [name]: name == "regimeChoice" ?
        checked ? "NEW" : "OLD"
        : checked ? "1" : "0"
    }))
  }

  const submitGeneralRules = (e) => {
    e.preventDefault()

    const formData = {
      path: saveTDSGeneralRulePath,
      data: {
        userId: user.user_id,
        regimeChoice: genaralState.regimeChoice,
        proofUploadMandatory: genaralState.proofUploadMandatory,
        "12bb_form_deadline": genaralState["12bb_form_deadline"],
        gracePeriod: genaralState.gracePeriod,
        isAllowLatePenalty: genaralState.isAllowLatePenalty,
        activateLateSubmissionPenalty: genaralState.activateLateSubmissionPenalty,
        deadLineType: genaralState.deadLineType,
        calculationMethod: genaralState.calculationMethod,
        lateSubmissionGracePeriod: genaralState.lateSubmissionGracePeriod,
        penaltyType: genaralState.penaltyType,
        penaltyAmount: genaralState.penaltyAmount,
        penaltyDetectFromPayroll: genaralState.penaltyDetectFromPayroll,
        penaltyMaximumCap: genaralState.penaltyMaximumCap,
        penaltyNotificationAction: genaralState.penaltyNotificationAction,
        autoExcemptOptions: genaralState.autoExcemptOptions.toString(),
        manualOverrideExceptions: genaralState.manualOverrideExceptions,
        auditNote: genaralState.auditNote,
        deviceName: "laptop",
        ipAddress: genaralState.ipAddress
      }

    }


    const isAllEmpty = Object.entries(genaralState)
      .filter(([key]) => key !== "userId") // userId को exclude किया
      .every(([_, value]) => value === "" || value === null || value === undefined || value === " ");
    if (isAllEmpty) {
      toast.error("Please select required fields first")
    } else {
      dispatch(tdsSaveData(formData))
    }
  }

  useEffect(() => {
    if (tdsStore.tdsSuccess) {
      toast.success(tdsStore.tdsMessage)
      dispatch(initTdsState())
    }

    if (tdsStore.tdsGenSuccess) {
      setGeneralState((pre) => ({
        ...pre,
        userId: user.user_id,
        regimeChoice: tdsStore.tdsGenData.regimeChoice, // OLD or NEW
        proofUploadMandatory: tdsStore.tdsGenData.proofUploadMandatory,
        "12bb_form_deadline": tdsStore.tdsGenData["12bb_form_deadline"],
        gracePeriod: tdsStore.tdsGenData.gracePeriod,
        isAllowLatePenalty: tdsStore.tdsGenData.isAllowLatePenalty,
        activateLateSubmissionPenalty: tdsStore.tdsGenData.activateLateSubmissionPenalty,
        deadLineType: tdsStore.tdsGenData.deadLineType,
        calculationMethod: tdsStore.tdsGenData.calculationMethod,
        lateSubmissionGracePeriod: tdsStore.tdsGenData.lateSubmissionGracePeriod,
        penaltyType: tdsStore.tdsGenData.penaltyType,
        penaltyAmount: tdsStore.tdsGenData.penaltyAmount,
        penaltyDetectFromPayroll: tdsStore.tdsGenData.penaltyDetectFromPayroll,
        penaltyMaximumCap: tdsStore.tdsGenData.penaltyMaximumCap,
        penaltyNotificationAction: tdsStore.tdsGenData.penaltyNotificationAction,
        autoExcemptOptions: tdsStore.tdsGenData.autoExcemptOptions.split(","),
        manualOverrideExceptions: tdsStore.tdsGenData.manualOverrideExceptions,
        auditNote: tdsStore.tdsGenData.auditNote,
        deviceName: tdsStore.tdsGenData.deviceName,
        ipAddress: tdsStore.tdsGenData.ipAddress
      }))

      dispatch(initGenRules())
    }


  }, [tdsStore])



const resetForm = () => {
  // 1️⃣ Reset local state
  setGeneralState((prev) => ({
    ...prev,
    ...defaultGeneralState,
  }));

  // 2️⃣ Dispatch API call
    const formData = {
      path: saveTDSGeneralRulePath,
      data: {
        ...defaultGeneralState,
        autoExcemptOptions: "",
        deviceName: "",
        ipAddress: "",
      },
    };
    dispatch(tdsSaveData(formData));
};

  return (
    <div className='setting-border p-4 height-auto'>

      <h3 className='text-purple font-weight-200 d-flex align-items-center justify-content-start gap-1 mb-4'>
        <IoSettings style={{ fontSize: "14px", position: "relative", top: "-5px" }} />
        <IoSettings style={{ fontSize: "14px", position: "relative", left: "-5px" }} />
        General Rules</h3>

      <div className=''>
        <Row>
          <Col sm="6">
            <div className='semi-card d-flex align-items-center justify-content-between gap-2'>
              <div>
                <h3 className='color-white mb-2 font-weight-200' >Allow Regime Choice</h3>
                <h5 className='color-gray font-weight-200'>Enable employees to toggle between Old/New tax regime</h5>
              </div>

              <Switch name="regimeChoice" checked={genaralState.regimeChoice === "NEW"} onChange={handleSwitchChange} />
            </div>
          </Col>

          <Col sm="6">
            <div className='semi-card d-flex align-items-center justify-content-between gap-2'>
              <div>
                <h3 className='color-white mb-2 font-weight-200' >Proof Upload Mandatory</h3>
                <h5 className='color-gray font-weight-200'>Require supporting documents for all deduction claims</h5>
              </div>

              <Switch name="proofUploadMandatory" checked={genaralState.proofUploadMandatory === "1"} onChange={handleSwitchChange} />
            </div>
          </Col>

          <Col sm="6" className='mt-4 mb-4'>
            <div className='semi-card'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <h3 className='color-white mb-2 font-weight-200' >12BB Submission Deadline</h3>
                <FaCalendarAlt className='text-purple' />
              </div>

              <Row>
                <Col sm="6">
                  <Form.Group>
                    <Form.Label className='color-white'>Month</Form.Label>
                    <Form.Select onChange={handleInputChange} name="month" className='universal-input' placeholder='December'>
                      <option value={""} key={0}>{"Select Month"}</option>
                      {
                        monthNames.map(item => {
                          return <option value={item} key={item}>{item}</option>
                        })
                      }

                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col sm="6">
                  <Form.Group>
                    <Form.Label className='color-white'>Day</Form.Label>
                    <Form.Select name="12bb_form_deadline" value={genaralState["12bb_form_deadline"]} onChange={handleInputChange} className='universal-input' placeholder='December'>
                      <option value={""}>Select Day</option>
                      {
                        getDaysInMonth(2025, 10).map((item) => {
                          return <option value={item.date} key={item.date}>{item.date}</option>
                        })
                      }
                    </Form.Select>
                  </Form.Group>
                </Col>

                <h5 className='color-gray font-weight-200 font-4 mt-2 d-flex align-items-center gap-2'> <FaCircleInfo /> Employees will receive automatic reminders 15, 7, and 1 day before deadline</h5>
              </Row>

            </div>
          </Col>

          <Col sm="6" className='mt-4 mb-4'>
            <div className='semi-card'>
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <h3 className='color-white mb-3 font-weight-200' >Grace Period</h3>
                <FaLock className='text-purple' />
              </div>

              <div className='d-flex align-items-center  gap-2'>
                <Form.Group>
                  <Form.Control name="gracePeriod" value={genaralState.gracePeriod} className='universal-input' placeholder='7' style={{ width: "50px" }} onChange={handleInputChange} />
                </Form.Group>
                <span className='color-white font-weight-200'>days after deadline for late submissions</span>
              </div>

              <h5 className='color-gray font-weight-200 font-4 mt-2 d-flex align-items-center gap-2'> <Form.Group>
                <Form.Check name="isAllowLatePenalty" checked={genaralState.isAllowLatePenalty === "1"} className='' placeholder='December' onChange={handleSwitchChange} />
              </Form.Group> Apply late submission penalty
              </h5>
            </div>
          </Col>
        </Row>


        {
          genaralState.isAllowLatePenalty === "1" ? <LateSubmissionPenaltySettings genaralState={genaralState} handleSwitchChange={handleSwitchChange} handleInputChange={handleInputChange} toggleValue={toggleValue} /> : null
        }

        <div className='d-flex align-items-center justify-content-center gap-3'>
          <button className='d-flex align-items-center justify-content-center gap-1 universal-btn border-radius-8px' onClick={submitGeneralRules}> <FaSave /> Save All Settings</button>
          <button className='d-flex align-items-center justify-content-center gap-1 universal-sec-btn border-radius-8px' onClick={resetForm}> <FaArrowRotateLeft />Reset Defaults</button>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div >
  )
}

export default GeneralRules